<ng-container *ngIf="canCreateOrder$ | async; else noCheckoutAllowed">
  <div class="checkout-header">
    <p-steps [model]="wizard.steps" [(activeIndex)]="wizard.currentStep"></p-steps>
  </div>

  <ng-container [ngSwitch]="wizard.steps[wizard.currentStep].automationId">
    <vnm-shopping-cart *ngSwitchCase="CheckoutWizardStepsEnum.Cart" [shoppingCart]="shoppingCart"></vnm-shopping-cart>
    <vnm-checkout-order
      *ngSwitchCase="CheckoutWizardStepsEnum.Billing"
      [@enterTrigger]="'switchFade'"
      [shoppingCart]="shoppingCart"
      (canDeactivate)="onActivationChange($event)"
    ></vnm-checkout-order>
    <vnm-checkout-booking
      *ngSwitchCase="CheckoutWizardStepsEnum.Booking"
      [@enterTrigger]="'switchFade'"
      [shoppingCart]="shoppingCart"
      (canDeactivate)="onActivationChange($event)"
    ></vnm-checkout-booking>
    <vnm-stripe-payment
      *ngSwitchCase="CheckoutWizardStepsEnum.Payment"
      [@enterTrigger]="'switchFade'"
      [shoppingCart]="shoppingCart"
      (paymentSuccess)="onPaymentSuccess($event)"
    ></vnm-stripe-payment>
    <div *ngSwitchCase="CheckoutWizardStepsEnum.Receipt">
      <vnm-checkout-receipt [orderId]="wizard.order.id"></vnm-checkout-receipt>
    </div>

    <p-footer *ngIf="showFooter()" class="sticky-footer">
      <div class="flex flex-column gap-md">
        <div *ngIf="shoppingCart.requiresShipping">
          <div
            class="text-right font-bold"
            [translateParams]="{ amount: shoppingCart.expectedShipping | currency }"
            translate
          >
            shopping-cart.expected-shipping
          </div>
        </div>

        <div
          class="text-right font-bold"
          [translateParams]="{ amount: shoppingCart.expectedSubtotal | currency }"
          translate
        >
          shopping-cart.expected-subtotal
        </div>

        <div *ngFor="let tax of shoppingCart.taxes" class="flex flex-column gap-sm">
          <div class="text-right font-bold">{{ tax.description }}: {{ tax.amount | currency }}</div>
        </div>

        <div
          class="text-right font-bold"
          [translateParams]="{ amount: shoppingCart.expectedTotal | currency }"
          translate
        >
          shopping-cart.expected-total
        </div>
      </div>
      <ng-container *ngIf="shoppingCart.cartItems.length">
        <button
          type="button"
          pButton
          *ngIf="shoppingCart.cartItems.length"
          [label]="labelForStep(wizard.currentStep)"
          (click)="nextStep()"
          icon="fa fa-arrow-right"
          iconPos="right"
          class="p-button-lg p-button-success w-full"
          [disabled]="wizard.running"
        ></button>
      </ng-container>
    </p-footer>
  </ng-container>
</ng-container>

<ng-template #noCheckoutAllowed>
  <div class="p-3 w-full">
    <p-message severity="warn" [text]="'shopping-cart.checkout-not-allowed' | translate" class="w-full"></p-message>
  </div>
</ng-template>
